import loadMore from './loadmore'
import popoverDrag from './drag'
import debounce from './debounce'
const directives = {
    loadMore,
    popoverDrag,
    debounce
}
 
export default {
    install(Vue) {
        Object.keys(directives).forEach((key) => {
            Vue.directive(key, directives[key])
        })
    },
}